import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { useContentSelectors } from "../../../../../store/content/content.selectors";
import { useMobileMenuState } from "../../../../../store/mobileMenu/mobileMenu.selectors";

import { useI18tools } from "../../../../../hooks";

import { Divider } from "../../../../ui/Divider/Divider";
import { DropDownItem } from "../DropDownItem/DropDownItem";
import { addStyles } from "./addsStyles";

import { BoxWrapper } from "../../../../box-wrapper/BoxWrapper.styled";
import { List, Wrapper } from "./DropDownMenu.styled";

export const DropDownMenu = ({ isOpen, type, closeMenu, setIsHovering }) => {
  const [selectedIndex, setSelectedIndex] = useState(null);
  const { t } = useTranslation();
  const menuRef = useRef(null);
  const isMobileOpen = useMobileMenuState();
  const location = useLocation();

  const isTools = type === "tools";

  const { menuProxies } = useContentSelectors();

  // const tools = useMemo(() => t("header.tools", { returnObjects: true }), [t]);
  const { tools } = useI18tools();

  const data = isTools ? tools : menuProxies;

  const handleMouseEnter = () => {
    setIsHovering(true);
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
    closeMenu();
  };

  useEffect(() => {
    const handleClickOutside = event => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        closeMenu();
      }
    };
    const mobile = navigator.userAgentData?.mobile;

    if (isOpen && !mobile && !isMobileOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, closeMenu, isMobileOpen]);

  useEffect(() => {
    if (isOpen) {
      const currentPath = location.pathname;

      const newPath = currentPath.startsWith("/uk")
        ? currentPath.slice(3)
        : currentPath;

      const foundItem = data.find(item => item.link === newPath);

      if (foundItem) {
        setSelectedIndex(foundItem.id);
      } else {
        setSelectedIndex(null);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, isOpen]);

  return (
    <Wrapper
      isOpen={isOpen}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      ref={menuRef}
    >
      <BoxWrapper addStyles={addStyles}>
        <List container component="ul" isTools={isTools}>
          {!isTools && (
            <>
              <DropDownItem
                icon="server"
                title={t("header.proxies.title")}
                description={t("header.proxyDescription.freeProxy")}
                price="0"
                link="/free-proxy-server"
                isTools={isTools}
                closeMenu={closeMenu}
              />
              <Divider styles={{ mb: 2 }} />
            </>
          )}
          {!!data?.length &&
            Array.isArray(data) &&
            data.map((item, idx) => (
              <DropDownItem
                key={idx}
                {...item}
                isTools={isTools}
                closeMenu={closeMenu}
                onClick={() => setSelectedIndex(item.id)}
                isActive={selectedIndex === item.id}
              />
            ))}
        </List>
      </BoxWrapper>
    </Wrapper>
  );
};
